import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-policy-yes-no-toggle',
  templateUrl: './policy-yes-no-toggle.component.html',
  styleUrls: ['./policy-yes-no-toggle.component.css']
})
export class PolicyYesNoToggleComponent {
  @Input() label = '';
  @Input() helpText?: string;
  @Input() value = false;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<boolean>();

  set(next: boolean): void {
    if (this.disabled || this.value === next) return;
    this.value = next;
    this.valueChange.emit(next);
  }
}
